// extracted by mini-css-extract-plugin
module.exports = {"cardsCtaWrapper":"StartPageHero_cardsCtaWrapper__8QorW","hero":"StartPageHero_hero__f9tU3"};